module.exports = __webpack_public_path__ + "img/1511263459.44b661be.jpg";